<template>
  <div class="p-20px">
    <el-card shadow="never">
      <template #header>
        <div class="flex items-center gap-8px">
          <Icon icon="ep:school" :size="18" />
          <span class="font-600">机构资料</span>
        </div>
      </template>
      <el-empty description="玄学机构功能建设中">
        <template #image>
          <Icon icon="ep:school" :size="64" class="text-[#c0c4cc]" />
        </template>
        <div class="text-14px text-[#909399] leading-6 max-w-480px text-left mx-auto">
          <p>当前版本已完成机构入驻链路：</p>
          <p>· 用户在 C 端提交机构入驻申请（企业信息 + 账号凭证）</p>
          <p>· 平台在「商家入驻审核」中完成审核</p>
          <p>· 审核通过后自动开通本机构台（以申请时填写的账密登录）</p>
          <p class="mt-8px">机构服务目录、师傅挂靠、订单与结算等功能将随版本逐步开放。</p>
        </div>
      </el-empty>
    </el-card>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'MerchantXuanxueInstitution' })
</script>
